export default __webpack_public_path__ + "static/media/gifbanner.7fe66d67.gif";